import { render } from "./ViewDelete.vue?vue&type=template&id=2dd1af7a"
import script from "./ViewDelete.vue?vue&type=script&lang=js"
export * from "./ViewDelete.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.8.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__